
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vermietung/[id]",
      function () {
        return require("private-next-pages/vermietung/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vermietung/[id]"])
      });
    }
  